global.SubmitParentForm = function(element) {
  element.change(function() {
    $('#js-search-results').html('<div class="loading-spinner"></div>')
    var form = $(element).closest('form');
    form.submit();

    $('#js-last-updated-date').html('Just Now');
  });
};
